var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// import * as _ from "lodash";
import * as React from "react";
var WithOnResize = /** @class */ (function (_super) {
    __extends(WithOnResize, _super);
    function WithOnResize(props) {
        var _this = _super.call(this, props) || this;
        _this.onResize = function () {
            var nextWidth = _this.getNextWidth();
            var nextHeight = _this.getNextHeight();
            _this.setState(function (previous) {
                return {
                    height: nextHeight,
                    width: nextWidth
                };
            });
        };
        _this.getNextWidth = function () {
            var _a = _this.props, maxWidth = _a.maxWidth, widthFactor = _a.widthFactor;
            var nextWidth = document.documentElement.clientWidth * widthFactor;
            if (maxWidth && nextWidth > maxWidth) {
                nextWidth = maxWidth;
            }
            return nextWidth;
        };
        _this.getNextHeight = function () {
            var _a = _this.props, maxHeight = _a.maxHeight, heightFactor = _a.heightFactor, useWidthForHeight = _a.useWidthForHeight;
            var nextHeight = (useWidthForHeight
                ? document.documentElement.clientWidth
                : document.documentElement.clientHeight) * heightFactor;
            if (maxHeight && nextHeight > maxHeight) {
                nextHeight = maxHeight;
            }
            return nextHeight;
        };
        var nextWidth = _this.getNextWidth();
        var nextHeight = _this.getNextHeight();
        _this.state = {
            height: nextHeight,
            width: nextWidth
        };
        return _this;
        // this.onResize = _.debounce(this.onResize, 200);
    }
    WithOnResize.prototype.componentDidMount = function () {
        window.addEventListener("resize", this.onResize);
    };
    WithOnResize.prototype.render = function () {
        var children = this.props.children;
        var _a = this.state, width = _a.width, height = _a.height;
        return children(width, height);
    };
    return WithOnResize;
}(React.Component));
export default WithOnResize;
//# sourceMappingURL=WithOnResize.js.map